import React from 'react'
import  './loading.css'



const Loading = () => {
  return (
    <div className="load">
      <div className="row">
      <div className="container">
          <div className="cards">
            <div className="card_image loading"></div>
            <div className="card_title loading"></div>
            <div className="card_button loading"></div>
            <div className="card_button loading"></div>
            <div className="card_description loading"></div>
          </div>
      </div>
    </div>
    </div>

    
  )
}

export default Loading
